/**
 * SxaProcessAreaTargetTile.js
 *
 * Copyright (c) 2018-2019 i-Solutions Global Ltd. All Rights Reserved.
 *
 * This software is the confidential and proprietary information of
 * i-Solutions Global Ltd. ("Confidential Information").  You shall
 * not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into
 * with i-Solutions Global Ltd.
 *
 * I-SOLUTIONS GLOBAL LTD MAKES NO REPRESENTATIONS OR WARRANTIES ABOUT
 * THE SUITABILITY OF THE SOFTWARE, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT
 * LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
 * PARTICULAR PURPOSE, OR NON-INFRINGEMENT. I-SOLUTIONS GLOBAL LTD SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE AS A RESULT OF USING, MODIFYING OR
 * DISTRIBUTING THIS SOFTWARE OR ITS DERIVATIVES.
 *
 * Version 1.0
 */

import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import ButtonBase from '@material-ui/core/ButtonBase';
import axios from "axios";

/*
  Removed alignment of button label - default center
  textAlign: 'left',
    justifyContent: 'center',
 */

const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        minWidth: 100,
        width: '100%',
        border: 1,
    },
    button: {
        height: 64,
        width: '100%',
        minWidth: 100,
        fontFamily: 'Open Sans, sans-serif',
        fontSize: 14,
        backgroundColor: '#6e8cc4',
        color: "white",
        paddingLeft: 12,
        paddingRight: 12,
        marginBottom: 2,
    },
    buttonSelected: {
        height: 64,
        width: '100%',
        minWidth: 100,
        fontSize: 14,
        fontFamily: 'Open Sans, sans-serif',
        fontWeight: 'bold',
        backgroundColor: 'white',
        color: "#1e2b56",
        paddingLeft: 12,
        paddingRight: 12,
        marginBottom: 2,
    },
    buttonDisabled: {
        disabled: 'true',
        height: 64,
        width: '100%',
        minWidth: 100,
        fontSize: 14,
        fontFamily: 'Open Sans, sans-serif',
        backgroundColor: 'lightgrey',
        color: 'darkgrey',
        paddingLeft: 12,
        paddingRight: 12,
        marginBottom: 2,
        cursor: 'default'
    }
});

class SxaProcessAreaTargetTile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            par: props.par
        };
        this.handleClick = this.handleClick.bind(this);
    }

    updateSelection(sel) {
        // Update state to reflect the input selected flag
        this.setState(prevState => ({
            par: {
                ...prevState.par,
                selected: sel
            }
        }));
    }

    updateEnabled(enabled) {
        // Update state to reflect the input enabled flag
        this.setState(prevState => ({
            par: {
                ...prevState.par,
                enabled: enabled
            }
        }));
    }

    handleClick() {
        console.log("PA " + this.state.par.oid + " clicked");

        // If the PA is selected already then ignore
        if (this.state.par.selected === true) {
            console.log("PA " + this.state.par.oid + " already selected; ignoring click");
            return;
        }

        // Set the PA as the current PA on the Assessment
        var url = 'api/assessment/selectPAWithGet?paid=' + this.state.par.oid + '&paselected=' + this.state.par.selected;
        axios.get(url)
            .then(response => {
                //console.log(response.data);

                // Signal the change to the selected PA (if any) as a new current Q
                // N.B. parent container handles de-selection, etc.?
                this.props.handleSelectionChange(response.data);
            })
            .catch(err => console.error(err))
    }

    render() {
        const {classes} = this.props;
        return (
            <React.Fragment>
                {this.state.par ? (
                    <div className={classes.root} >
                        {this.state.par.enabled ?
                            <ButtonBase align="right" onClick={this.handleClick} variant="outlined" color="primary"
                                        className={this.state.par.selected ? classes.buttonSelected : classes.button}
                            >
                                {this.state.par.name}
                            </ButtonBase>
                            :
                            <ButtonBase align="right" variant="outlined" color="primary"
                                        className={classes.buttonDisabled}
                            >
                                {this.state.par.name}
                            </ButtonBase>
                        }
                    </div>
                ) : "No Process Area found"}
            </React.Fragment>
        );
    }
}

SxaProcessAreaTargetTile.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SxaProcessAreaTargetTile);